// extracted by mini-css-extract-plugin
export var container = "_8v-0";
export var icon = "_8v-1";
export var text = "_8v-2";